// ============= Imports =============
import {
  ApiResponse,
  FetchDataProps,
  User,
} from '../../../components/container/forms/types/api/graph.types';
import { tokenManager } from '@tw/tw-component-library';

// ============= Constants =============
const BASE_URL = import.meta.env.VITE_BASE_URL;
const API_ENDPOINT = '/api/Graph/users/search';
const AXIS_SCOPE = 'api://f23d5e95-70a8-4aca-b373-e23d8c9f6454/access_as_user';

const HEADERS: Record<string, string> = {};

// ============= Types =============
// interface GraphHeaders extends Record<string, string> {
//   Authorization: string;
//   ConsistencyLevel: string;
// }

// ============= Utility Functions =============
/**
 * Constructs filter parameters for Graph API query
 * @param searchValue Search term to filter users
 * @returns Formatted filter string
 */
// const constructFilterParams = (searchValue: string): string => {
//   return [
//     `startswith(givenName,'${searchValue}')`,
//     `startswith(surname,'${searchValue}')`,
//     `startswith(userPrincipalName,'${searchValue}')`,
//   ].join(' or ');
// };

/**
 * Creates headers for Graph API request
 * @param token Authentication token
 * @returns Headers object
 */
const createHeaders = (token: string, spoofedUser: string | undefined) => ({
  Authorization: `Bearer ${token}`,
  ...HEADERS,
  ...(spoofedUser ? { 'x-Spoof-User': spoofedUser } : {}),
});

// ============= Main Function =============
/**
 * Fetches users from Microsoft Graph API based on search criteria
 * @param getAccessToken Function to acquire access token
 * @param searchValue Search string to filter users
 * @returns Promise with API response containing user data or error
 */
export const getUsers = async ({
  getAccessToken,
  searchValue,
  spoofedUserEmail,
  office,
}: FetchDataProps): Promise<ApiResponse<User[]>> => {
  try {
    console.log('🔄 Fetching Graph API data...');

    // Token acquisition with required scopes

    const token = await getAccessToken([AXIS_SCOPE]);
    if (!token) {
      throw new Error('Failed to acquire Graph API token');
    }
    tokenManager.logTokenInfo(token, 'Graph API');

    // URL construction
    // const filterParams = constructFilterParams(searchValue);
    const url = `${BASE_URL}${API_ENDPOINT}?searchTerm=${searchValue}&limit=50${
      office ? `&office=${office}` : ''
    }`;
    console.log('🌐 Making request to:', url);
    // API request
    const response = await fetch(url, {
      method: 'GET',
      headers: createHeaders(token, spoofedUserEmail),
    });

    // Response handling
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('✅ Graph API data fetched successfully', data);

    return {
      success: true,
      data,
    };
  } catch (error) {
    console.error('🔴 Error fetching Graph API data:', error);
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'An unknown error occurred',
    };
  }
};
